import { render, staticRenderFns } from "./numGrow.vue?vue&type=template&id=3edb6ac9"
import script from "./numGrow.vue?vue&type=script&lang=js"
export * from "./numGrow.vue?vue&type=script&lang=js"
import style0 from "./numGrow.vue?vue&type=style&index=0&id=3edb6ac9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports